var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-alert',{attrs:{"dismissable":"","type":"error"},model:{value:(_vm.alert),callback:function ($$v) {_vm.alert=$$v},expression:"alert"}},[_vm._v(" Error :"+_vm._s(_vm.error)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }